import MaterialNameStack from '#/modules/imsMgmt/receipts/shared/MaterialNameStack';

function formatWarehouseLabel(row) {
  const warehouse = row?.warehouse;
  if (!warehouse) {
    return '-';
  }

  return [warehouse.code, warehouse.name].filter(Boolean).join(' ')
    || warehouse.id
    || '-';
}

export function renderStockNoScannedRow(row) {
  const availableQty = row?.availableQty ?? row?.systemQty ?? row?.baseQty ?? 0;
  return (
    <div className="min-w-0 w-full flex items-center justify-between gap-3">
      <div className="min-w-0 flex items-start gap-5">
        <div className="min-w-0 shrink-0 space-y-1">
          <p className="font-mono text-sm font-medium text-slate-800">
            {row.stockNo || '—'}
          </p>
          <p className="text-xs text-muted-foreground">
            {formatWarehouseLabel(row)}
          </p>
        </div>

        <div className="min-w-0 pt-0.5">
          <MaterialNameStack
            name={row.mtr?.name}
            code={row.mtr?.mtrNo}
          />
        </div>
      </div>

      <p className="shrink-0 text-right text-sm text-muted-foreground">
        可用量：
        <span className="text-base font-medium text-slate-800 tabular-nums">
          {availableQty || '—'}
        </span>
      </p>
    </div>
  );
}

export function renderStockNoAmbiguousRow(row) {
  const availableQty = row?.availableQty ?? row?.systemQty ?? row?.baseQty ?? 0;
  return (
    <div className="min-w-0 w-full space-y-1">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 space-y-1">
          <p className="font-mono text-sm font-medium text-slate-800">
            {row.stockNo || '—'}
          </p>
          <p className="text-xs text-muted-foreground">
            {formatWarehouseLabel(row)}
          </p>
        </div>

        <p className="shrink-0 text-right text-sm text-muted-foreground">
          可用量：
          <span className="text-base font-medium text-slate-800 tabular-nums">
            {availableQty || '—'}
          </span>
        </p>
      </div>

      <div className="min-w-0 pt-0.5">
        <MaterialNameStack
          name={row.mtr?.name}
          code={row.mtr?.mtrNo}
        />
      </div>
    </div>
  );
}
